import React from 'react';
import './App.scss';
import HomePage from './views/home/HomePage';

function App() {
  return (
    <div className="App">
      <HomePage></HomePage>
    </div>
  );
}

export default App;
